'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../styleInject.js');

var css_248z = ".ClaimStatusChip-module_chipContent__qaZ-P{align-items:center;grid-template-columns:1em 1fr}";
var styles = {"chipContent":"ClaimStatusChip-module_chipContent__qaZ-P"};
styleInject["default"](css_248z, '17861981-d036-4e48-991c-96f0713ae5a4');

exports["default"] = styles;
